import React from 'react';

import PageHeader from 'components/shared/PageHeader/PageHeader';

const ScreenWrapper = ({ title, children }) => (
  <div className="flex h-full w-full flex-col">
    <PageHeader title={title} className="shrink-0" />
    <div className="flex min-h-0 w-full flex-1 flex-col overflow-hidden">{children}</div>
  </div>
);

export default ScreenWrapper;
